<div class="confirmation-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-content">
      <div class="dialog-icon" [style.color]="data.iconColor">
        <mat-icon>{{ data.icon }}</mat-icon>
      </div>
      <h2 mat-dialog-title>{{ data.title }}</h2>
    </div>
  </div>

  <!-- Dialog Content -->
  <mat-dialog-content class="dialog-content">
    <p class="dialog-message">{{ data.message }}</p>
  </mat-dialog-content>

  <!-- Dialog Actions -->
  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-button">
      {{ data.cancelText }}
    </button>
    <button 
      mat-raised-button 
      [color]="data.confirmButtonColor" 
      (click)="onConfirm()" 
      class="confirm-button">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
